import React, { useEffect } from "react";
import { Box, Image, Text, Flex } from "@chakra-ui/react";
import { formatTextWithLineBreaks } from "../../../utils/formatText";
import { fetchTeachersData } from "../../../services/homeContentService";
import "./profiles.css";
import Loader from '../../../components/common/Loader'
import { useState } from "react";

function Profiles() {
  const [profiles, setProfiles] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null)

  const managerProfile = profiles.find((profile) => profile.id === 0);
  const otherProfiles = profiles.filter((profile) => profile.id !== 0);

  useEffect(() =>{
    const fetchData = async() => {
      try{
        const response = await fetchTeachersData();
        setProfiles(response || []);
      } catch (error){
        setError("Failed to load profiles");
      }finally{
        setLoading(false);
      }
    };
    fetchData();  
  }, [])

  if(loading){
    return <Loader />;
  }
  if (error) {
    return <Text color="red">{error}</Text>;
  }

  const background = "#CBD5E0";
  return (
    <Box
      className="about-us-container"
      width="100%"
      height="100%"
      bgImage="url('https://leadguitar.s3.eu-north-1.amazonaws.com/images/progilebg1.jpeg')"
      bgSize="cover"
      bgPosition="center"
      bgRepeat="no-repeat"
      zIndex="-1"
      p={4}
      id="profiles"
    >
            {managerProfile && (
        <Flex
          className="manager-profile"
          justifyContent="center"
          mb={{ md: "8" }}
        >
          <Flex
            flexDirection="column"
            alignItems="center"
            textAlign="center"
            justifyContent="space-evenly"
            p={4}
            width={{ base: "100%", md: "80%" }}
          >
            <Image
              src={managerProfile.path}
              alt={`${managerProfile.name}`}
              width="25dvh"
              height="25dvh"
              borderRadius="50%"
              border="1px solid black"
              mb={4}
              objectFit={"cover"}
            />
            <Box
              bg={background}
              marginTop="1vh"
              textAlign="right"
              dir="rtl"
              padding="10px"
            >
              <Text fontSize="2.5dvh" align="center">
                <b>{managerProfile.name}</b>
              </Text>
              <Text fontSize="1.8dvh" whiteSpace="pre-wrap" padding="1.5dvh">
                {formatTextWithLineBreaks(managerProfile.text)}
              </Text>
            </Box>
          </Flex>
        </Flex>
      )}
      <Flex
        className="profiles-container"
        justifyContent="center"
        gap={{ md: "8" }}
        flexWrap="wrap"
      >
        {otherProfiles.map((profile) => (
          <Flex
            className="profile-container"
            key={profile.id}
            flexDirection="column"
            alignItems="center"
            textAlign="center"
            justifyContent="space-evenly"
            p={4}
          >
            <Image
              src={profile.path}
              alt={`${profile.name}`}
              width="20dvh"
              height="20dvh"
              borderRadius="50%"
              border="1px solid black"
              mb={4}
              objectFit={"cover"}
            />
            <Box
              bg={background}
              marginTop="1vh"
              width="45dvh"
              textAlign="right"
              dir="rtl"
            >
              <Text fontSize="2.5dvh" textAlign="center">
                <b>{profile.name}</b>
              </Text>
              <Text fontSize="1.8dvh" padding="1.5dvh">
                {formatTextWithLineBreaks(profile.text)}
              </Text>
            </Box>
          </Flex>
        ))}
      </Flex>
    </Box>
  );
}

export default Profiles;
